(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      var check_JS_load = true;
      function loadFunction() {
          if (check_JS_load) {
              check_JS_load = false;

              handleAskAnExpertClick();
              handleBuyNowClick();
          }
      }

      function eventLoad() {
          ['keydown', 'mousemove', 'touchstart'].forEach((event) => {
              document.addEventListener(event, () => {
                  loadFunction();
              });
          });
      }
      eventLoad();

      function handleAskAnExpertClick() {
        document.body.addEventListener('click', function (e) {
          const link = e.target.closest('.ask-an-exp__button-link');
          if (!link) return;

          e.preventDefault();
          const link_id = link.getAttribute('href');
          const dialog = document.querySelector(link_id);
          if (dialog && typeof dialog.open === 'function') {
            dialog.open();
          }
        }, false);
      }

      function handleBuyNowClick() {
        const buyNowButton = document.querySelector('.product-button-buy-now .button');
        if (!buyNowButton) return;

        buyNowButton.addEventListener('click', function (event) {
          event.preventDefault();

          const anchorHref = buyNowButton.getAttribute('href');
          if (!anchorHref) return;

          const checkoutContainer = document.querySelector(anchorHref);
          if (!checkoutContainer) return;

          const buyItNowBtn = checkoutContainer.querySelector('shopify-buy-it-now-button button');
          if (buyItNowBtn) {
            buyItNowBtn.click();
          }
        }, false);
      }
    });
  
  } catch(e) { console.error(e); }
})();
})();
